import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

const StepHeading = styled.h2`
    ${tw`mt-4 font-black text-center text-3xl sm:text-4xl lg:text-5xl text-center  leading-tight mb-16`}
`;
const HorizontalSteps = ({ heading, steps = null }) => {


    const { t } = useTranslation();

    const defaultSteps = [
        { heading: t("steps.register"), description: t("steps.registerDesc") },
        { heading: t("steps.buy"), description: t("steps.buyDesc") },
        { heading: t("steps.declare"), description: t("steps.declareDesc") },
        { heading: t("steps.receive"), description: t("steps.receiveDesc") },
    ];
    if (!steps) steps = defaultSteps;

    return (
        <div className="bg-gray-100 py-20 px-4">
            <StepHeading>
            {heading || (
                    <>
                       Как это <span className="text-green-600">работает?</span>

                    </>
                )}
            </StepHeading>

            <div className="flex flex-col items-center space-y-12 md:space-y-0 md:flex-row md:justify-center md:space-x-10 max-w-6xl mx-auto">
                {steps.map((step, index) => (
                    <div key={index} className="flex flex-col items-center text-center max-w-[220px]">
                        <div className="mb-6 flex flex-col items-center">
                            <div className="w-12 h-12 bg-[#0ABD19] text-white text-xl font-bold rounded-full flex items-center justify-center shadow-md">
                                {(index + 1).toString().padStart(2, "0")}
                            </div>
                        </div>
                        <div className="text-lg font-semibold h-[48px] flex items-center justify-center mb-2">
                            {step.heading}
                        </div>
                        <p className="text-gray-600 text-sm leading-relaxed h-[42px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HorizontalSteps;
